export default function getBrowser() {
  // Opera 8.0+
  let isOpera =
    (!!(window as any)?.opr && !!(window as any)?.opr?.addons) ||
    !!(window as any)?.opera ||
    navigator.userAgent.indexOf(' OPR/') >= 0;

  // Safari 3.0+ "[object HTMLElementConstructor]"
  let isSafari =
    /constructor/i.test(window.HTMLElement as any) ||
    ((p) => {
      return p.toString() === '[object SafariRemoteNotification]';
    })(!window['safari'] || (window as any).safari.pushNotification);

  // Internet Explorer 6-11
  let isIE = /*@cc_on!@*/ false || !!(document as any).documentMode;

  // Edge 20+
  let isEdge = !isIE && !!window.StyleMedia;

  // Chrome 1+
  let isChrome = !!(window as any).chrome && !!(window as any).chrome.webstore;

  // Blink engine detection
  let isBlink = (isChrome || isOpera) && !!window.CSS;

  return isOpera
    ? 'opera'
    : isSafari
    ? 'safari'
    : isChrome
    ? 'chrome'
    : isIE
    ? 'ie'
    : isBlink
    ? 'blink'
    : isEdge
    ? 'edge'
    : '';
}
